<template>
  <path
    d="M3 5.00018V19.0002C3 20.1002 3.89 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018H5C3.89 3.00018 3 3.90018 3 5.00018ZM15 9.00018C15 10.6602 13.66 12.0002 12 12.0002C10.34 12.0002 9 10.6602 9 9.00018C9 7.34018 10.34 6.00018 12 6.00018C13.66 6.00018 15 7.34018 15 9.00018ZM6 17.0002C6 15.0002 10 13.9002 12 13.9002C14 13.9002 18 15.0002 18 17.0002V18.0002H6V17.0002Z"
  />
</template>
